import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "COA · Crimes of Art";
const DEFAULT_DESC =
  "The definitive library and publication documenting art crime, law, and controversy.";

export const Seo = ({ title, description, image, type = "article" }) => {
  const fullTitle = title ? `${title} · COA` : SITE;
  const desc = (description || DEFAULT_DESC).slice(0, 300);
  const url = typeof window !== "undefined" ? window.location.href : "";
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
};

export default Seo;
